import React from 'react'
import './IconButton.css'

const IconButton = ({ children, ...rest }) => (
  <button className="IconButton" {...rest}>
    {children}
  </button>
)

export default IconButton



// WEBPACK FOOTER //
// ./src/components/IconButton.js